export default __webpack_public_path__ + "static/media/AddIcon.4a16bb21.svg";